export namespace UtilsModels {
  export type Nullable<T> = { [K in keyof T]: T[K] | null };
  export type StringOrEmpty = string | null | undefined;
  export type NumberOrEmpty = number | null | undefined;

  export enum NotFoundTemplates {
    Default,
    InviteNotFound,
    InviteAccepted,
    NotPermitted,
  }
}
